// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBPoUyYz34e4d2bZVKOS_pin4T921cRLUw",
    authDomain: "pccamp-a6cca.firebaseapp.com",
    databaseURL: "https://pccamp-a6cca.firebaseio.com",
    storageBucket: "pccamp-a6cca.appspot.com",
    messagingSenderId: '621926117959'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
